import {ErrorResponse, NetworkParams, RestService} from "@sinossi/mates-react-library";

export class DocumentServices
{
    static getDocuments = (request: {pageSize: number, pageId: number, orderType: string|null, orderBy: string|null}, callback: any, catchCallback: any) => {
        let searchParams: URLSearchParams = new URLSearchParams()
        searchParams.append("pageSize", "" + request.pageSize)
        searchParams.append("pageId", "" + request.pageId)

        if(request.orderType && request.orderBy) {
            searchParams.append("orderType", request.orderType!.toString())
            searchParams.append("orderBy", request.orderBy!.toString())
        } else {
            searchParams.append("orderType", "ASCENDING")
            searchParams.append("orderBy", "name")
        }

        RestService
            .get<any>(`/api/document`, NetworkParams.EMPTY, searchParams)
            .then(callback)
            .catch(catchCallback)
    }

    static deleteDocument = (documentId: string, callback: any, catchCallback: any) => {
        RestService
            .delete(`/api/document/${documentId}`)
            .then(callback)
            .catch(catchCallback)
    }

    static uploadDocument = (request: FormData, callback: any, catchCallback: any) => {
        const params = new NetworkParams()
        params.contentType = undefined

        RestService
            .genericPost<any, ErrorResponse>(`/api/document`, request, params)
            .then(callback)
            .catch(catchCallback)
    }
}
